import { InputGroup, Input, InputGroupText, Row, Col } from "reactstrap";
import { useTranslation } from "react-i18next";
import ProgressBarr from "../statisticComplonent/ProgressBar";
const OptionsForm = ({
  optionsData,
  sum,
  multiChoice,
  sumVote,
  j,
  handelOptionSelect,
  progresbarChart
}) => {
  const { t } = useTranslation();
  return (
    <Row style={{ alignItems: "center", justifyContent: "center" }}>
      {multiChoice ? (
        <small className="fw-semibold w-100 ms-1 my-1">
          {t("choose one or more answers")}
        </small>
      ) : (
        <small className="fw-semibold w-100 ms-1 my-1">
          {t("choose only one answer")}
        </small>
      )}

      {optionsData?.map((ele, i) =>
        multiChoice ? (
          <Col
            style={{ margin: "5px" }}
            className="mb-md-0 mb-1"
            key={"optionitemname" + i + "hhh"}
            md="6"
            sm="12"
          >
            <InputGroup className="Quiz2inputs">
              <InputGroupText>
                <div className="form-check">
                  <Input
                    type="checkbox"
                    name={`OPTION-${i}-${j}`}
                    id="exampleCustomCheckbox"
                    className="Quiz2Formelement"
                    value={`${i},${j}`}
                    onChange={(e) => handelOptionSelect(e, i,j)}
                  />
                </div>
              </InputGroupText>
              <Input
                type="text"
                style={{ fontSize: "19px" }}
                readOnly={true}
                value={ele.opt_text}
              />
            </InputGroup>
            {progresbarChart ? (
              <ProgressBarr sum={sum} count={ele.AnswersCount} />
            ) : (
              ""
            )}
          </Col>
        ) : (
          <Col
            md="6"
            sm="12"
            key={"optionitemname" + i + "hhh"}
            style={{ margin: "5px" }}
          >
            <InputGroup className="Quiz2inputs">
              <InputGroupText>
                <div className="form-check">
                  <Input
                    type="radio"
                    className="Quiz2Formelement"
                    name={`OPTION-${j}`}
                    id="exampleCustomRadio"
                    onChange={(e) => handelOptionSelect(e, i,j)}
                    value={`${i},${j}`}
                  />
                </div>
              </InputGroupText>
              <Input
                type="text"
                onChange={(e) => handelOptionSelect(e)}
                value={ele.opt_text}
                placeholder="Message"
                readOnly={true}
              />
            </InputGroup>
            {progresbarChart ? (
              <ProgressBarr sum={sum} count={ele.AnswersCount} />
            ) : (
              ""
            )}
          </Col>
        )
      )}
    </Row>
  );
};

export default OptionsForm;
